module.exports = __webpack_public_path__ + "img/key.94cde88c.svg";